'use strict';

import jQuery from 'jquery';
import cookie from './../../../vendor/jquery.cookie';
import Core from './../../Core/Core';
import AlphabeticalList from '../../AlphabeticalListPage/AlphabeticalList.js';

/**
 * ShowListPage
 *
 * JavaScript functions for the list page of all shows
 */
var ShowListPage = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      privateNS.alphabeticalList = new AlphabeticalList({
        container: '#show-list-page'
      });

      // Return the public namespace
      return publicNS;
    };
    
    /**
     * Handle toggles of the filter for shows with video
     *
     * @param $event
     */
    privateNS.toggleVideoFilter = function toggleVideoFilter($event) {

      // Extract the video filter state
      var videoFilter = $(this)[0].checked;

      // Store the users preference of filtered versus unfiltered video
      $.cookie('shows_video_filter', videoFilter);

      // Toggle the states of the alphabetical controls to match the filter
      privateNS.toggleAlphaControlStates(videoFilter,'video');

      // Toggle the state of the filter class based on the value of the input
      privateNS.$container.find('.list-alphabetical').toggleClass(
        'filter-for-video',
        videoFilter
      );
    };

    /**
     * Handle toggles of the filter for shows with passport video
     * @param $event
     */
    privateNS.togglePassportFilter = function togglePassportFilter($event) {
      let ppFilter = $(this)[0].checked;
      $.cookie('shows_passport_filter', ppFilter);
      privateNS.toggleAlphaControlStates(ppFilter,'passport');
      privateNS.$container.find('.list-alphabetical').toggleClass('filter-for-passport', ppFilter);

      // shows with passport videos are a subset of shows with videos.
      // if the passport video filter is checked, the video filter should be checked and disabled.
      let videoCheckbox = $('#alphabetical-shows-video-toggle');

      if (ppFilter) {
        if (!videoCheckbox.prop('checked')) {
          videoCheckbox.click();
        }
        // the video checkbox has to be checked if the passport box is checked.
        videoCheckbox.attr("disabled", true);
      } else {
        // keep the videos checkbox enabled if the user unchecks the passport checkbox.
        videoCheckbox.attr("disabled", false);
        privateNS.toggleAlphaControlStates(1,'video');
      }
    };

    /**
     * Toggles the states of the alpha controls
     */
    privateNS.toggleAlphaControlStates = function toggleAlphaControlStates(state, typeOfToggle) {
      if (typeOfToggle == 'video') {
        privateNS.$container.find('.alphabetical-controls .alphabetical-control.has-genre:not(.has-video)').toggleClass('enabled', !state);
      } else if (typeOfToggle == 'passport') {
        privateNS.$container.find('.alphabetical-controls .alphabetical-control:not(.has-passport-video)').toggleClass('enabled', !state);
      }
    };

    /**
     * Handles restoring the user's state when loading the all shows page
     *
     * @param {jQuery.event} $event The triggering event from jQuery
     */
    privateNS.onPageLoad = function onPageLoad($event) {

      // first, check if we should default to the passport filter
      let passportDefault = $('#defaultToPassport');

      if (passportDefault.length) {
        let passportFilterPreference = $.cookie('shows_passport_filter');

        if (passportFilterPreference) {
          // this trigger will set the cookie as a side effect
          privateNS.$container.find('.alphabetical-shows-passport-toggle').prop('checked', true).trigger('change');
        }
      }

      // Check to see if the user has a video filter preference
      var videoFilterPreference = $.cookie('shows_video_filter');

      // If the video filter preference is set, restore the checkbox to the
      // preferred state
      if (videoFilterPreference) {

        // Restore the value that is in the cookie and trigger a change on
        // the checkbox to notify the UI. Notice that the filter preference
        // is tested against the string "true". Cookies store their boolean
        // values as strings.
        privateNS.$container.find('.alphabetical-shows-video-toggle').
          prop('checked', videoFilterPreference === 'true').
          trigger('change');
      }

      // do the same for the passport filter.
      let passportFilterPreference = $.cookie('shows_passport_filter');

      if (passportFilterPreference) {
        privateNS.$container.find('.alphabetical-shows-passport-toggle').prop('checked', passportFilterPreference === 'true').trigger('change');
      }

    };

    /**
     * Attaches event handlers
     */
    privateNS.attachHandlers = function() {
      $(window).on(
        'load',
        privateNS.onPageLoad
      );
      
      // Attach the video filter control
      privateNS.$container.find('.alphabetical-shows-video-toggle').on(
        'change',
        privateNS.toggleVideoFilter
      );

      privateNS.$container.find('.alphabetical-shows-passport-toggle').on(
        'change',
        privateNS.togglePassportFilter
      );

      // When a show is clicked, set the autoplay cookie to true
      privateNS.$container.find('.video-item-preview').on(
        'click',
        function () {

          // Set the URL for the clicked element
          var url = $(this).parent('a').attr('href');

          // Set the autoplay cookie for the client
          Core.AutoPlayCookie.addAutoplayURL(url);
        }
      );
    };

    // Return a new instance
    return privateNS.init();
  };
})(jQuery);

export default ShowListPage